<div class="mat-elevation-z8">
    <table  mat-table [dataSource]="dataSource">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef width ="30%"> Name </th>
            <td mat-cell *matCellDef="let element" width ="30%"> {{element?.drugName}} </td>
        </ng-container>

        <!-- strength Column -->
        <ng-container matColumnDef="strength">
            <th mat-header-cell *matHeaderCellDef width ="10%"> Strength </th>
            <td mat-cell *matCellDef="let element" width ="10%"> {{element?.strength}} </td>
        </ng-container>

        <!-- NDC Column -->
        <ng-container matColumnDef="drugNumber">
            <th mat-header-cell *matHeaderCellDef width ="10%"> Drug Number </th>
            <td mat-cell *matCellDef="let element" width ="10%"> {{element?.ndc}} </td>
        </ng-container>


      <!-- priority Column -->
      <ng-container matColumnDef="priority">
          <th mat-header-cell *matHeaderCellDef width ="10%"> Priority </th>
          <td mat-cell *matCellDef="let element" width ="10%"> {{element?.priority}} </td>
      </ng-container>

        <!-- dcrAge Column -->
        <ng-container matColumnDef="dcrAge">
            <th mat-header-cell *matHeaderCellDef width ="10%"> DCR Age </th>
            <td mat-cell *matCellDef="let element" width ="10%"> {{element?.age}} </td>
        </ng-container>

        <!-- status Column -->
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef width ="10%"> Status </th>
            <td mat-cell *matCellDef="let element" width ="10%"> {{element?.sfStatus}} </td>
        </ng-container>

        <!-- caseNumber Column -->
        <ng-container matColumnDef="caseNumber">
        <th mat-header-cell *matHeaderCellDef width="10%" data-testclass = "header-casenumber-dcr-druglist"> Case Number </th>
        <td mat-cell *matCellDef="let element" width="10%" data-testclass = "cell-casenumber-dcr-druglist">
        <label *ngIf="!element?.caseUrl" data-testclass = "casenumber-dcr-druglist" >{{ element?.caseNumber }} </label>
        <a *ngIf="element?.caseUrl" [href]="element?.caseUrl" target="_blank" data-testclass = "hyperlink-casenumber-dcr-druglist">
            {{ element?.caseNumber }}
        </a>
        </td>
        </ng-container>

        <!-- caseOwner Column -->
        <ng-container matColumnDef="caseOwner">
            <th mat-header-cell *matHeaderCellDef width ="10%"> Case Owner</th>
            <td mat-cell *matCellDef="let element" width ="10%"> {{element?.owner}} </td>
        </ng-container>

         <!-- caseSource Column -->
         <ng-container matColumnDef="caseSource">
            <th mat-header-cell *matHeaderCellDef width ="10%"> Case Source</th>
            <td mat-cell *matCellDef="let element" width ="10%"> {{element?.source}} </td>
        </ng-container>

        <!-- manufacturer Column -->
        <ng-container matColumnDef="manufacturer">
            <th mat-header-cell *matHeaderCellDef width ="10%">Manufacturer </th>
            <td mat-cell *matCellDef="let element" width ="10%"> {{element?.manufacturer}} </td>
        </ng-container>

        <ng-container matColumnDef="action" >
          <th mat-header-cell *matHeaderCellDef  width ="5%">  </th>
          <td mat-cell *matCellDef="let element" width ="5%">
             <mat-icon (click)="openImportWizardDcrDetails(element?.caseNumber)"  style="margin-bottom: 2px; cursor: pointer;">
            <img src="/assets/img/icons/ico.12.arwrgt.svg" alt="">
        </mat-icon>
      </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row (click)="selectedRow = row" [ngClass]="{ 'highlight': row === selectedRow }" *matRowDef="let row; columns: displayedColumns;"></tr>


    </table>
     <table>
        <tr *ngIf="dataSource?.data.length==0">
            <td style="text-align: center;" [attr.colspan]="displayedColumns.length">
                No Records Found!
            </td>
        </tr>
    </table>
  <span (click)="openImportWizardDcrDrug()">Show More ></span>
  </div>

